<template lang="html">
  <div class='sticky-footer-container'>
    <slot/>
  </div>
</template>
<script>
export default {
  name: "StickyFooter",
};
</script>

<style lang="css" scoped>
@media (max-width: 960px) {
  .sticky-footer-container {
    position: fixed;
    padding:8px;
    bottom:0;
    left:0;
    right:0;
    background-color: white;
    -webkit-box-shadow: 0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12);
    box-shadow: 0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12);
  }
}
</style>
<style lang="css" >
body {
  padding-bottom:75px;
  background-color: #ebebeb;
}
</style>





// WEBPACK FOOTER //
// src/components/StickyFooter.vue